module.exports = __webpack_public_path__ + "static/media/end_report.ce24de7d.png";